import React from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton({ href }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-btn"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 left-5 z-40 group"
    >
      {/* ripple rings */}
      <span className="absolute inset-0 rounded-full bg-[#25D366]/60 animate-soft-ping" />
      <span className="absolute inset-0 rounded-full bg-[#25D366]/35 animate-soft-ping" style={{ animationDelay: "0.6s" }} />

      {/* main button */}
      <motion.span
        animate={{ rotate: [0, -10, 0, 10, 0] }}
        transition={{ duration: 2.6, repeat: Infinity, repeatDelay: 1.6, ease: "easeInOut" }}
        className="relative w-14 h-14 rounded-full bg-gradient-to-br from-[#25D366] via-[#1ebe5a] to-[#128C7E] flex items-center justify-center shadow-2xl shadow-emerald-500/40 hover:scale-110 active:scale-95 transition-transform"
      >
        <MessageCircle className="w-6 h-6 text-white drop-shadow" strokeWidth={2.4} />
        {/* unread dot */}
        <span className="absolute -top-0.5 -right-0.5 w-4 h-4 rounded-full bg-rose-500 border-2 border-[#05060F] flex items-center justify-center text-[9px] font-bold text-white">
          1
        </span>
      </motion.span>

      {/* chat bubble tooltip */}
      <motion.span
        initial={{ opacity: 0, x: -6, scale: 0.94 }}
        animate={{ opacity: [0, 1, 1, 0], x: [-6, 0, 0, -6] }}
        transition={{ duration: 5, repeat: Infinity, repeatDelay: 4, times: [0, 0.1, 0.9, 1] }}
        className="hidden sm:flex absolute left-16 top-1/2 -translate-y-1/2 whitespace-nowrap pointer-events-none"
      >
        <span className="relative glass-strong border border-white/10 text-xs font-medium px-3 py-2 rounded-xl shadow-lg">
          Namaste 🙏 Chat with us on WhatsApp
          <span className="absolute -left-1 top-1/2 -translate-y-1/2 w-2 h-2 rotate-45 bg-[rgba(10,10,26,0.78)] border-l border-b border-white/10" />
        </span>
      </motion.span>
    </a>
  );
}
